import React from "react";
var __jsx = React.createElement;
import { Drawer } from "vaul";
import { DrawerPortal } from "@/components/Drawer";
import { Dialog, DialogContent } from "@/components/Dialog";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
var MenuActionsModal = function MenuActionsModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    actions = _ref.actions,
    title = _ref.title;
  var isMobile = useIsMobile();
  var handleActionClick = function handleActionClick(action) {
    var _action$onClick;
    (_action$onClick = action.onClick) === null || _action$onClick === void 0 ? void 0 : _action$onClick.call(action);
    onClose();
  };
  var content = /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 pb-4 pt-10"
  }, title && /*#__PURE__*/React.createElement("h3", {
    className: "text-base font-bold py-1"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 w-full "
  }, actions.map(function (action) {
    return /*#__PURE__*/React.createElement("div", {
      key: action.value,
      className: "hover:bg-gray-200 cursor-pointer flex items-center gap-3 px-6 py-4   border-[1px] border-solid border-[#D6DFE9] shadow-xs rounded-lg  transition-colors w-full font-medium",
      onClick: function onClick() {
        return handleActionClick(action);
      }
    }, action.icon && /*#__PURE__*/React.createElement(Icon, {
      icon: action.icon,
      className: "text-[#020202]",
      width: 5,
      height: 5
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-base"
    }, action.label));
  })));
  return /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(Drawer.Root, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    },
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DrawerPortal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: "fixed inset-0 bg-[#071425] opacity-80 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "bg-white flex flex-col rounded-t-[10px] fixed bottom-0 left-0 right-0 z-[9999] py-4 px-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F]"
  })), content)))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: "max-w-md p-6",
    haveClose: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F]"
  })), content))));
};
export default MenuActionsModal;